// Webpack Imports
import * as bootstrap from 'bootstrap';

( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );
} )();

( function ($){

	$(document).ready(function(){

		//mobile menu header
		$("#header_mobile_burger").click(toggleMobileMenu);
		$("#menu_mobile_overlay").click(toggleMobileMenu);
		$("#menu_mobile_close").click(toggleMobileMenu);

		//mobile menu footer
		$("#footer_mobile_menu > nav h5").click(toggle_footer_mobile_menu);

		//HOME - collections populaires
		$("#home_collections_populaires .owl-carousel").owlCarousel({
			items : 1,
		});
		$("#home_collections_populaires .filter span").click(home_toggle_filter);

		//HOME - comment commander
		$("#home_comment_commander .owl-carousel").owlCarousel({
			items : 2,
			nav : true,
			slideBy : 2,
			dots : false,
			responsive : {
				992 : {
					items : 4
				}
			}
		});

		//HOME - Vos espaces
		$("#home_vos_espaces .filter span").click(home_toggle_filter);

		//HOME - Livraison
		$("#home_livraison .owl-carousel").owlCarousel({
			items : 3,
			nav : false,
			slideBy : 1,
			dots : true,
			responsive : {
				992 : {
					items : 4
				}
			}
		});

		//HOME - Avis client
		$("#home_avis_clients .owl-carousel").owlCarousel({
			items : 1,
			nav : true,
			slideBy : 1,
			dots : false,
			responsive : {
				992 : {
					items : 3
				}
			}
		});

        //SLIDER PRODUCT
        window.relatedProductCarousel = $(".product_slider_related");
        $(".product_slider_related .owl-carousel").owlCarousel({
           items: 1,
           responsive : {
               992 : {
                   items : 4
               }
           }
        });
        window.additionalProductCarousel = $(".product_slider_additional");
        $(".product_slider_additional .owl-carousel").owlCarousel({
            items: 1,
            responsive : {
                992 : {
                    items : 4
                }
            }
        });

		//Form password strength
		$('body').on( 'keyup', 'form.check_password_strength input[type=password].password_1,form.check_password_strength input[type=password].password_2',function() {
			checkPasswordStrength(
				$('input[type=password].password_1'),         // First password field
				$('input[type=password].password_2'), 		// Second password field
				$('#password_strength'),            // Strength meter
				$('button[type=submit]')           // Submit button
			);
		});

		//apparition du block adresse de factu dans les formulaires
		$('body').on('change','input[name="show_billing_adress"]',function(){

			if($(this).val() === "yes"){
				$("#infos_facturation").removeClass("d-none");
			}
			else{
				$("#infos_facturation").addClass("d-none");
			}
		});

		//Mon compte - order
		//Accordeon order
		$('body').on('click','.other_order_item .order_header',function(){
			const global_wrapper = $(this).parent().parent()
			const item_wrapper = $(this).parent();

			if(item_wrapper.hasClass("open")){
				item_wrapper.removeClass("open")
			}
			else if($(global_wrapper).find(".open").length > 0) {
				$(global_wrapper).find(".open").removeClass("open").one("transitionend",function(){
					item_wrapper.addClass("open")
				})
			}
			else{
				item_wrapper.addClass("open")
			}

		});

		//Mon comte - favoris & offres
		//Cta afficher plus de produit
		$('body').on('click','.see_more_cta', function(){

			const wrapper = $(this).closest(".see_more_wrapper");
			const show_count = wrapper.attr("see_more_count") ? parseInt(wrapper.attr("see_more_count")):6;

			//no wrapper found
			if(wrapper.length === 0){
				return;
			}

			//if no more item, hide cta
			if(wrapper.find(".see_more_item").length <= show_count)
				$(this).addClass("d-none");

			//show hidden item
			wrapper.find(".see_more_item").each(function(key){
				if(key === show_count)
					return false;

				$(this).removeClass("see_more_item");
			});

		});

		//Mon commpte - Mes informations
		//Suppression d'une adresses
		$('body').on('click','a.my_account_delete_address', function ( e ) {

			e.preventDefault();

			var confirmDelete = confirm( "Voulez-vous vraiment supprimer cette adresse ?" );

			if ( ! confirmDelete ) {
				return;
			}

			const name = $( this ).attr( 'id' );

			$.ajax( {
				url: woo_address_book.ajax_url,
				type: 'post',
				data: {
					action: 'wc_address_book_delete',
					name: name,
					nonce: woo_address_book.delete_security,
				},
				success: function () {
					$("#"+name+"_item").hide();
				}
			} );
		} );

		//resize des blocks pour alignement sur desktop
		resizeMyAccountInformationBlock();
		$(window).resize(resizeMyAccountInformationBlock);

		//image cliquable mega menu
		addLinkToImageInMegaMenu();

		//menu déroulant blog
		$('body').on('click',"#blog_sidebar .sidebar_block h4",function(){
			$(this).parent().toggleClass("open");
		});


		if ($('.qty').length) {
			$('.qty').attr('disabled', 'disabled');
		}
		$('#shipping_method > li > label').text('');

        if ($('.woof_submit_search_form').length) {
            $('.woof_submit_search_form').text('Voir les produits');
        }

        if ($('.variation-color-link').length) {
            $('.variation-color-link').first().click();
            // $('#pa_dimension').prop('selectedIndex', 1);
            // $('#pa_finition').prop('selectedIndex', 1);
		}

        window.wc_payment_methods = $('.wc_payment_methods_wrapper');
        window.place_order = $('.place-order');
        window.payment_transfer = $('.payment-transfer');

        $('.woocommerce-checkout-payment').remove();

        if ($('.wc_payment_methods').length) {
			$('.wc_payment_methods').change();
        }

        if ($('.checkout_address_item_shipping').length) {
            $('.checkout_address_item_shipping').first().addClass('selected');
        }

        if ($('#checkout_save_has_billing_adress').length) {
            $('#checkout_save_has_billing_adress').first().attr('checked', true);
            $('#checkout_save_has_billing_adress').first().change();
        }
        if ($('input[name="shipping_method_delivery"]').length) {
            $('input[name="shipping_method_delivery"]').first().attr('checked', true);
            $('input[name="shipping_method_delivery"]').first().change();
        }

        if ($('.woocommerce-cart-form').length) {
            $('button[name="update_cart"]').removeAttr('disabled');
            $('button[name="update_cart"]').click();
		}
	});

	function toggleMobileMenu(){
		$("#menu_mobile").toggleClass("open");

		$("#menu_mobile").on('transitionend webkitTransitionEnd oTransitionEnd', function () {
			if($("#menu_mobile").hasClass("open"))
				$("#menu_mobile").addClass("opened");
			else
				$("#menu_mobile").removeClass("opened");
		});
	}
	function home_toggle_filter(){
		if($(this).hasClass("active"))
			return false;


		$(this).parent().find("span").removeClass("active");
		$(this).addClass("active");

		$(this).parent().parent().find(".content_wrapper .content").removeClass("active");
		$(this).parent().parent().find(".content_wrapper .content[type='"+$(this).attr("type")+"']").addClass("active");
	}
	function toggle_footer_mobile_menu(){
		const menu = $(this).parent().find(".footer_collapsed_menu");
		const final_height = $(this).parent().find(".footer_collapsed_menu ul").outerHeight();

		if($(menu).hasClass("open")){
			$(menu).removeClass("open").css("max-height","0");
		}else{
			$(menu).addClass("open").css("max-height",final_height+"px");
		}

	}
	function checkPasswordStrength( $pass1, $pass2, $strengthResult, $submitButton ) {

		const pass1 = $pass1.val();
		const pass2 = $pass2.val();

		//Reset
		$submitButton.attr( 'disabled', 'disabled' );
		$strengthResult.removeClass( 'short bad good strong' );

		// Get the password strength
		// const strength = wp.passwordStrength.meter( pass1, [], pass2 );
        //
		// // Add the strength meter results
		// switch ( strength ) {
        //
		// 	case 2:
		// 		$strengthResult.addClass( 'bad' ).find(".password_strength_string").html( pwsL10n.bad );
		// 		break;
        //
		// 	case 3:
		// 		$strengthResult.addClass( 'good' ).find(".password_strength_string").html( pwsL10n.good );
		// 		break;
        //
		// 	case 4:
		// 		$strengthResult.addClass( 'strong' ).find(".password_strength_string").html( pwsL10n.strong );
		// 		break;
        //
		// 	case 5:
		// 		$strengthResult.addClass( 'short' ).find(".password_strength_string").html( pwsL10n.mismatch );
		// 		break;
        //
		// 	default:
		// 		$strengthResult.addClass( 'short' ).find(".password_strength_string").html( pwsL10n.short );
        //
		// }

		// submit enable only if password strenght is 4
		// and second password not empty
        if (pass2.trim() !== '' && pass1.trim() === pass2.trim() && pass2.length > 7) {
		// if ( strength >= 0 && strength <= 4 && pass2.trim() !== '' ) {
        	$submitButton.removeAttr('disabled');
		}

		// return strength;
	}
	function resizeMyAccountInformationBlock(){

		if($("#mes_adresses_block_listing").length <= 0)
			return;

		if(window.innerWidth >= 991){

			$("#mes_adresses_block_listing").css("height","");
			$("#mes_informations_block_connexion").css("height","");
			$("#mes_adresses_block_add").css("height","");
			$("#mes_informations_block_personnelles").css("height","");

			const connection_block_height = $("#mes_informations_block_connexion").outerHeight();
			const address_block_height = $("#mes_adresses_block_listing").outerHeight();
			const personnal_block_height = $("#mes_informations_block_personnelles").outerHeight();
			const address_form_block_height = $("#mes_adresses_block_add").outerHeight();

			if(connection_block_height > address_block_height){
				$("#mes_adresses_block_listing").css("height",connection_block_height+"px");
			}else if(connection_block_height < address_block_height){
				$("#mes_informations_block_connexion").css("height",address_block_height+"px");
			}

			if(personnal_block_height > address_form_block_height){
				$("#mes_adresses_block_add").css("height",personnal_block_height+"px");
			}else if(personnal_block_height < address_form_block_height){
				$("#mes_informations_block_personnelles").css("height",address_form_block_height+"px");
			}

		}else{
			$("#mes_adresses_block_listing").css("height","");
			$("#mes_informations_block_connexion").css("height","");
			$("#mes_adresses_block_add").css("height","");
			$("#mes_informations_block_personnelles").css("height","");
		}
	}

	//rend cliquable une image située sous un lien dans le méga menu
	function addLinkToImageInMegaMenu(){

		//target all the image-widget in the mega menu
		$("#header_desktop .mega-menu .widget_media_image").each(function() {

			//if parent contain a link, add it to the image widget
			if($(this).parent().find("a.mega-menu-link").length){
				const link = $(this).parent().find("a.mega-menu-link").attr("href");
				$(this).wrapInner("<a href='"+link+"'></a>")

			}
		});
	}

    $(document).on( 'click', '.single_add_to_cart_button_custom', function(e) {
        e.preventDefault();

    	if ($(this).hasClass('disabled')) {
    		return false;
		}

        var addButon = $(this);
        var form = addButon.closest('form.cart');
        var id = addButon.val();
        var product_qty = form.find('input[name=quantity]').val() || 1;
        var product_id = form.find('input[name=product_id]').val() || id;
        var variation_id = form.find('input[name=variation_id]').val() || 0;
        var free_product = form.find('input[name=free_product]').val() || 0;

        var data = {
            action: 'woocommerce_ajax_add_to_cart',
            product_id: product_id,
            product_sku: '',
            quantity: product_qty,
            variation_id: variation_id,
            free_product: free_product
        };

        $(document.body).trigger('adding_to_cart', [addButon, data]);

        $.ajax({
            type: 'post',
            url: wc_add_to_cart_params.ajax_url,
            data: data,
            beforeSend: function (response) {
                addButon.removeClass('added').addClass('loading');
            },
            complete: function (response) {
                addButon.addClass('added').removeClass('loading');
            },
            success: function (response) {
                if (response.error && response.product_url) {
                    $('.error-cart').hide();
                    if (response.error_msg && response.error_msg != '') {
                    	$('.error-cart').html(response.error_msg);
                        $('.error-cart').show();
                    } else {
                        window.location = response.product_url;
                    }
                    return;
                } else {
                    var popup = response.fragments.popup_cart;

                    $('.widget_shopping_cart_content').remove();
                    $('.product').first().append(popup);
                    $('body').first().append('<div class="modal-backdrop show"></div>');

                    $(".product_slider_related .owl-carousel").owlCarousel({
                        items: 1
                    });
                    $("#home_collections_populaires .owl-carousel").owlCarousel({
                        items: 1
                    });
                    $('html,body').animate({scrollTop: 0});
                }
            }
        });

        return false;
    });

	$(document).on('click', '.product-input-btn-plus-quantity', function(e){
		e.preventDefault();

		var index = $(this).data('index');
        var input = $('input[name="quantity"]').first();

		if (!input.length) {
            input = $('input[name="cart[' + index + '][qty]"]').first();

            if (!input.length) {
                input = $('.qty').first();
            }
		}

        var quantity = parseInt(input.val()) + 1;

		input.val(quantity);

        var infoBox = $('._m_boite[data-index="' + index + '"]').first();
        var surface = Math.round(parseFloat(infoBox.data('value') * quantity));

		var surfaceInput = $('.surface[data-index="' + index + '"]').first();
        surfaceInput.attr('data-value', surface);
        surfaceInput.val(surface);

        $('button[name="update_cart"]').removeAttr('disabled');
        $('button[name="update_cart"]').click();
    });

    $(document).on('click', '.product-input-btn-minus-quantity', function(e){
        e.preventDefault();

        var index = $(this).data('index');
        var input = $('input[name="quantity"]').first();

        if (!input.length) {
            input = $('input[name="cart[' + index + '][qty]"]').first();

            if (!input.length) {
                input = $('.qty').first();
            }
        }

        var quantity = parseInt(input.val()) - 1;

        if (quantity >= 0) {
			input.val(quantity);

            var infoBox = $('._m_boite[data-index="' + index + '"]').first();
            var surface = Math.round(parseFloat(infoBox.data('value') * quantity));

            var surfaceInput = $('.surface[data-index="' + index + '"]').first();
            surfaceInput.attr('data-value', surface);
            surfaceInput.val(surface);
            
            $('button[name="update_cart"]').removeAttr('disabled');
            $('button[name="update_cart"]').click();
        }
    });

    $(document).on('click', '.product-input-btn-plus-surface', function(e) {
        e.preventDefault();

        var index = $(this).data('index');
		var input = $('input[name="cart[' + index + '][surface]"]').first();

		if (!input.length) {
			input = $('input[name="surface"]').first();
		}

        var surface = parseInt(input.val()) + 1;

        input.val(surface);

        var infoBox = $('._m_boite[data-index="' + index + '"]').first();

        var quantity = Math.round(parseFloat(surface / infoBox.attr('data-value')));

        if (quantity < 1) {
            quantity = 1;
        }

        var quantityInput = $('input[name="quantity"]').first();

        if (!quantityInput.length) {
            quantityInput = $('input[name="cart[' + index + '][qty]"]').first();

            if (!quantityInput.length) {
                quantityInput = $('.qty').first();
            }
        }

        if (quantity != quantityInput.val()) {
            quantityInput.attr('data-value', quantity);
            quantityInput.val(quantity);

            $('button[name="update_cart"]').removeAttr('disabled');
            $('button[name="update_cart"]').click();
        }
    });

    $(document).on('click', '.product-input-btn-minus-surface', function(e){
        e.preventDefault();

        var index = $(this).data('index');
        var input = $('input[name="cart[' + index + '][surface]"]').first();

        if (!input.length) {
            input = $('input[name="surface"]').first();
        }

		var surface = parseInt(input.val()) - 1;

        var quantityInput = $('input[name="quantity"]').first();

        if (!quantityInput.length) {
            quantityInput = $('input[name="cart[' + index + '][qty]"]').first();

            if (!quantityInput.length) {
                quantityInput = $('.qty').first();
            }
        }

        if (surface > 0) {
            input.val(surface);

            var infoBox = $('._m_boite[data-index="' + index + '"]').first();
            var quantity = Math.round(parseFloat(surface / infoBox.data('value')));

            if (quantity < 1) {
                quantity = 1;
			}


            if (quantity != quantityInput.val()) {
                quantityInput.attr('data-value', quantity);
                quantityInput.val(quantity);

                $('button[name="update_cart"]').removeAttr('disabled');
                $('button[name="update_cart"]').click();
			}
        } else {
            quantityInput.attr('data-value', 0);
            quantityInput.val(0);

            $('button[name="update_cart"]').removeAttr('disabled');
            $('button[name="update_cart"]').click();
		}
	});

    $(document).on('change paste keyup', '.surface', function(e) {
        $('.reload-surface').show();
    });

    $(document).on('click', '.reload-surface', function(e){
    // $(document).on('keypress', '.surface', function(e) {
    //     var key = e.which;

        // if(key === 13) {
            e.preventDefault();

            var index = $(this).data('index');
            var input = $('input[name="cart[' + index + '][surface]"]').first();

            if (!input.length) {
                input = $('input[name="surface"]').first();
            }

            var surface = parseInt(input.val());

            var quantityInput = $('input[name="quantity"]').first();

            if (!quantityInput.length) {
                quantityInput = $('input[name="cart[' + index + '][qty]"]').first();

                if (!quantityInput.length) {
                    quantityInput = $('.qty').first();
                }
            }

            if (surface > 0) {
                var infoBox = $('._m_boite[data-index="' + index + '"]').first();

                var quantity = Math.round(parseFloat(surface / infoBox.attr('data-value')));

                if (quantity < 1) {
                    quantity = 1;
                }

                quantityInput.attr('data-value', quantity);
                quantityInput.val(quantity);

                $('button[name="update_cart"]').removeAttr('disabled');
                $('button[name="update_cart"]').click();
            } else {
                quantityInput.attr('data-value', 0);
                quantityInput.val(0);

                $('button[name="update_cart"]').removeAttr('disabled');
                $('button[name="update_cart"]').click();
            }
        // }
    });


    $(document).on('keypress', 'input[name="coupon_code"]', function(e) {
        var key = e.which;
        if(key === 13) {
            $('button[name=apply_coupon]').click();
            return false;
        }
    });

    $(document).on('keypress', 'input[name="calc_shipping_postcode"]', function(e) {
        var key = e.which;
        if (key === 13) {
            $('button[name=calc_shipping]').click();
            return false;
        }
    });

    $(document).on('change keyup', 'input[name="calc_shipping_postcode"]', function(e) {

        if ($(this).val().length >= 5) {
            $('button[name=calc_shipping]').click();
            return false;
        }
    });

    $(document).on('click', '.variation-color-link', function(e){
    	e.preventDefault();

        $('.variation-color-link').removeClass('mc-box-shadow');
        $(this).addClass('mc-box-shadow');
    	$('#pa_color').val($(this).data('variation'));
        $('#pa_color').change();
	});
    $(document).on('change', '#pa_color', function(e) {
        $('#pa_dimension').prop('selectedIndex', 1);
        $('#pa_dimension').change();
    });

    $(document).on('change', '#pa_dimension', function(e) {
    	$('#pa_finition').prop('selectedIndex', 1);
        $('#pa_finition').change();
    });

    $(document).on('click', '.tab-link', function(e) {
    	e.preventDefault();

        if ($(this).hasClass('active')){
            $(this).removeClass('active');
            $('#' + $(this).data('id')).hide();
		} else {
            $(this).addClass('active');
            $('#' + $(this).data('id')).show();
        }
	});

    $(document).on('change', 'input.variation_id', function(){
        if ($(this).val() != '') {
            $.blockUI({ message:''});

            var form = $(this).closest('form.cart');
            var variation_id = $(this).val();
            // var product_qty = form.find('input[name=quantity]').val() || 1;
            var product_id = form.find('input[name=product_id]').val();
            var data = {
                action: 'get_variation_infos',
                product_id: product_id,
                // quantity: product_qty,
                variation_id: variation_id,
            };
            $.ajax({
                type: 'post',
                url: wc_add_to_cart_params.ajax_url,
                data: data,
                success: function (response) {
                    $('.mc-product-description').html(response.description_short);

                    if ($('#tab-caracteristique').length) {
                        var html = '<table class="caracteristique-table">';
                        for (var i = 0; i < response.caracteristiques.length; i++) {
                            if (response.caracteristiques[i].slug == '_m_boite') {
                        		$('._m_boite').attr('data-value', response.caracteristiques[i].value.replace(',', '.'));
                                $('.price_alt').html(response.price);
                            }
							html += '<tr>';
							html += '<td class="caracteristique-label">' + response.caracteristiques[i].label + '</td>';
							html += '<td class="caracteristique-value"><img src="/wp-content/themes/moncarro/images/' + response.caracteristiques[i].slug.toLowerCase() + '.png">' + response.caracteristiques[i].value + '</td>';
							html += '</tr>';
                        }
                        html += '</table>';

                        $('#tab-caracteristique').html(html);
                    }
                    if ($('.woocommerce-Price-amount').length) {
                        $('.woocommerce-Price-amount').html(response.format_price);
                    }
                    if ($('.mc-livraison-txt').length) {
                        $('.mc-livraison-txt').html(response.livraison);
                    }
                    if ($('#tab-description').length) {
                        $('#tab-description').html(response.description);
                    }
                    if ($('.related-products').length) {
                        $('.related-products').html(response.related_products);
                        $(".product_slider_related .owl-carousel").owlCarousel({
                            items: 1
                        });
                    }
                    if ($('.product-stock').length) {
                    	$('.product-stock').html(response.stock);
					}
                    if ($('.product_title').length) {
                        $('.product_title').text(response.name);
                    }
                    if (response.unite != 'm2') {
                        $('.product-surface-inner').css('opacity', 0);
                    }
                    if (response.discount_price != '') {
                        if ($('.price-regular-s').length) {
                            $('.price-regular-s').text(response.discount_price);
                        }
                        if ($('.price-tag-discount-single').length) {
                            if (response.discount_percent.length) {
                                $('.price-tag-discount-single').text(response.discount_percent);
                                $('.price-tag-discount-single').show();
                            } else {
                                $('.price-tag-discount-single').hide();
                            }
                        }
                        $('.price-regular').show();
                    } else {
                        $('.price-regular-s').text('');
                        $('.price-tag-discount-single').text('');
                        $('.price-regular').hide();
                    }
                    $.unblockUI();
                }
            });
        }

    });
    
    $(document).on('click', '.free-sample-btn', function(e) {
    	if (!$(this).hasClass('disabled')) {
            $('input[name="free_product"]').val(1);
            $('.single_add_to_cart_button_custom').click();
		}
	});

    $(document).on('click', '.mc-product-filter-btn', function(e){
        e.preventDefault();

        if ($('.mc-product-filter-btn').hasClass('show')) {
            $('.mc-product-filter-btn').removeClass('show');
            $('.mc-product-filter-btn-txt').text('Filtrer');
            $('.mc-product-filter').hide();
        } else {
            $('.mc-product-filter-btn').addClass('show');
            $('.mc-product-filter-btn-txt').text('Masquer les filtres');
            $('.mc-product-filter').show();
		}

    });

    $(document).on('click', '#mc-filter-close-btn', function(e){
        e.preventDefault();

        $('.mc-product-filter-btn-txt').text('Filtrer');
        $('.mc-product-filter').hide();
    });

    $(document).on('click', '.mc-product-order-btn', function(e){
        e.preventDefault();

        $('.woocommerce-ordering').show();
    });

    $(document).on('click', '#mc-order-close-btn', function(e){
        e.preventDefault();

        $('.woocommerce-ordering').hide();
    });

    $(document).on('mouseover', '.mention-marge-link', function(e) {
        $('.mention-marge-box').show();
    });

    $(document).on('mouseout', '.mention-marge-link', function(e) {
		$('.mention-marge-box').hide();
    });

    $(document).on('mouseover', '.delivery-info-link', function(e) {
        $(this).parent().parent().find('.delivery-info-box').first().show();
    });

    $(document).on('mouseout', '.delivery-info-box', function(e) {
        $('.delivery-info-box').hide();
    });

    $(document).on('click', '.aws-search-field', function(e){
        e.stopPropagation();
    });

    $(document).on('click', 'body.search-open', function(e) {
        if ($('.header_search_wrapper').hasClass('visible')) {
            $('.header_search_wrapper').removeClass('visible');
            $('body').removeClass('search-open');
        }
    });

    $(document).on('click', '#header_mobile_loupe', function(e) {
       $('.header_search_wrapper').addClass('visible');
       $('body').addClass('search-open');

    });

    $(document).on('click', '.see-more-link', function(e) {
    	$('a[data-id="tab-description"]').click();
	});

	$(document).on('click', '#place_order_payment', function(e) {
		e.preventDefault();

		if (!$(this).hasClass('disabled') && !$('#customer_details').is(":hidden")) {
            $('.mc-checkout-error').hide();

            if (!$('#save_shipping_address').is(":hidden") || !$('#save_billing_address').is(":hidden")) {
                $('.mc-checkout-error').html('Veuillez enregistrer les modifications de votre adresse');
                $('.mc-checkout-error').show();
            } else if ($('input[name="create_quote"]').length && $('input[name="create_quote"]').val() == 1) {
				if (!$('.wc_payment_methods_wrapper').length) {
                    window.wc_payment_methods.insertBefore('#customer_details');
                }
                if (!$('.place-order').length) {
                    window.place_order.insertAfter('.woocommerce-checkout-review-order');
                }
                if (!$('.payment-transfer').length) {
                    window.payment_transfer.insertAfter(window.wc_payment_methods);
                }
                $('.wc_payment_methods_wrapper').hide();

                if ($('.wc_payment_methods').length) {
                    $('.wc_payment_methods').val('cheque').change();
                }
                $('#place_order').hide();
				$('#place_order').click();

            } else {
                $('html,body').animate({scrollTop: 0});
                $('#order-step-2').removeClass('current');
                $('#order-step-3').addClass('current');

                $('#customer_details').hide();
                $('.cart-warranty').hide();
                $(this).hide();
                if (!$('.wc_payment_methods_wrapper').length) {
                    window.wc_payment_methods.insertBefore('#customer_details');
                }
                if (!$('.place-order').length) {
                    window.place_order.insertAfter('.woocommerce-checkout-review-order');
                }
                if (!$('.payment-transfer').length) {
                    window.payment_transfer.insertAfter(window.wc_payment_methods);
                }
                $('#order_review_heading').text('Mes informations de paiement');
                $('.wc_payment_methods_wrapper').show();

                $('.shipping_method_block').hide();
                $('.woocommerce-additional-fields').hide();
                $('.mc-entry-title').text('Mes information de paiements');

                if ($('.wc_payment_methods').length) {
                    $('.wc_payment_methods').change();
                }
            }
		}
	});

    $(document).on('click', '#place_order_previous', function(e) {
        e.preventDefault();

        if ($('#customer_details').is(":hidden")) {
            $('html,body').animate({scrollTop: 0});

            $('#place_order_payment').show();
            $('#customer_details').show();
            $('.cart-warranty').show();
            $('.place-order').remove();
            $('.wc_payment_methods_wrapper').hide();
            $('.shipping_method_block').show();
            $('.woocommerce-additional-fields').show();
            $('.mc-entry-title').text('Mes information de livraison');
            $('.payment-transfer').hide();
		} else {
        	window.location.href = '/panier';
		}
    });

    $(document).on('change', '.wc_payment_methods', function(e) {
        $('#ppc-button-ppcp-gateway').hide();
        $('.payment-transfer').hide();
        $('#place_order').show();

        if ($(this).val() === 'bacs') {
            $('.payment-transfer').show();
        } else if ($(this).val() === 'ppcp-gateway') {
            $('#place_order').hide();
            $('#ppc-button-ppcp-gateway').show();
        }
        $('input[name="payment_method"]').val($(this).val());
	});

    $(document).on('click', '#cgv-checkbox', function(e) {
    	if ($('.cart-warranty input[type=checkbox]').is(':checked')) {
    		$('#place_order_payment').removeClass('disabled');
		} else {
            $('#place_order_payment').addClass('disabled');
		}
	});

    $(document).on('click', '#warranty-checkbox', function(e) {
    	if ($(this).is(':checked')) {
            var data = {
                product_slug: 'assurance-serenite',
                action: 'woocommerce_ajax_add_option'
            };
            $.ajax({
                type: 'post',
                url: wc_add_to_cart_params.ajax_url,
                data: data,
                success: function (response) {
                    $('button[name="update_cart"]').removeAttr('disabled');
                    $('button[name="update_cart"]').click();
                }
            });
        } else {
            window.location.href = $(this).attr('remove-url');
		}
	});

    $(document).on('change', 'input[name="checkout_save_has_billing_adress"]', function(e) {
    	if ($(this).val() == 0){
            $('#billing_address_block_listing').show();
            if ($('.checkout_address_item_billing').length) {
                $('.checkout_address_item_billing').first().addClass('selected');
                $('#billing_address_book').val($('.checkout_address_item_billing').first().data('value'));
                $('#billing_address_book').change();
            }
        } else if ($(this).val() == 1) {
            $('#billing_address_block_listing').hide();
            $('.woocommerce-billing-fields').hide();
            $('.billing_address').hide();
            $('#billing_address_book_field').hide();
		}
	});

    $(document).on('click', '.checkout_address_item_shipping', function(e) {
        $('.checkout_address_item_shipping').removeClass('selected');
		$(this).addClass('selected');

        // $('input[name="shipping_postcode"]').val($(this).attr('postcode'));

        $('#shipping_address_book').val($(this).data('value'));
        $('#shipping_address_book').change();

        // $('#shipping_postcode').val($(this).attr('postcode'));
    });

    $(document).on('click', '.checkout_address_item_billing', function(e) {
        $('.checkout_address_item_billing').removeClass('selected');
        $(this).addClass('selected');

        // $('#billing_postcode').val($(this).attr('postcode'));

        $('#billing_address_book').val($(this).data('value'));
        $('#billing_address_book').change();

        // $('#billing_postcode').val($(this).attr('postcode'));
    });

    $(document).on('click', '.my_account_edit_address_shipping', function(e) {
		$('.woocommerce-shipping-fields').show();
        $('.shipping_address').show();
		$('#ship-to-different-address').hide();
		$('#shipping_address_book_field').hide();
		$('#save_shipping_address').css('display', 'inline-block');

    	// e.stopPropagation();
    });

    $(document).on('click', '.my_account_edit_address_billing', function(e) {
        $('.woocommerce-billing-fields').show();
        $('.billing_address').show();
        // $('#billing_address_book_field').hide();
        $('#save_billing_address').css('display', 'inline-block');

        // e.stopPropagation();
    });

    $(document).on('change', 'input[name="shipping_method_delivery"]', function(e) {
        $('.shipping_method_detail_item').hide();

        $('.shipping_method_item').removeClass('show');
        $('#postponed_delivery_date').val('');

        if ($(this).val() == 0) {
        	selectShipping();
        } else if ($(this).val() == 1) {
            $('.shipping_method_detail_item').show();
            selectShipping();
        } else if ($(this).val() == 2 && $('input[name="shipping_method[0]"]').length) {
            $('input[name="shipping_method[0]"]').first().click();
		}
        $('#shipping_method_item_' + $(this).data('shipping-method')).addClass('show');

        e.stopPropagation();
    });

    function selectShipping() {
    	var totalWeight = $('.shipping_wrapper_inner').data('weight');
        var totalAmount = $('.shipping_wrapper_inner').data('amount');

        if ($('#shipping_method_item_free_shipping').length) {
            $('.shipping_method').each(function() {
                if ($(this).val().includes('free_shipping') == true){
                    $('#shipping_method_detail_item_delivery').show();
                    $(this).click();
                }
            });
        } else if (totalAmount == 0 || totalWeight <= 27) {
    		$('.shipping_method').each(function() {
                if ($(this).val().includes('boxtal_connect') == true){
                    $('#shipping_method_detail_item_delivery').show();
                    $(this).click();
				}
			});
		} else {
            $('.shipping_method').each(function() {
                if ($(this).val().includes('apg_shipping') == true){
                	$('#shipping_method_detail_item_delivery').show();
                    $(this).click();
                }
            });
        }
    }

    $(document).on('click', '#save_shipping_address', function(e) {
        e.preventDefault();

        $('.woocommerce-shipping-fields').hide();
        $('.shipping_address').hide();
        $('#ship-to-different-address').show();
        $('#shipping_address_book_field').show();
        $(this).hide();

        var data = {
            action: 'woocommerce_ajax_save_address',
            address_key: $('.checkout_address_item_shipping.selected').first().data('value'),
            address : {
            	first_name: $('#shipping_first_name').val(),
                last_name: $('#shipping_last_name').val(),
                company: $('#shipping_company').val(),
                address_name: $('#shipping_address_name').val(),
                address_1: $('#shipping_address_1').val(),
                address_2: $('#shipping_address_2').val(),
                city: $('#shipping_city').val(),
                postcode: $('#shipping_postcode').val(),
                country: $('#shipping_country').val(),
    		},
        };
        $.ajax({
            type: 'post',
            url: woo_address_book.ajax_url,
            data: data,
            success: function (response) {
            	var html = '<div class="address">';
            	html += '<span>' + response.first_name + ' ' + response.last_name + '</span><br/>';
                html += response.address_1 + '<br />';
                html += response.postcode + ' ' + response.city + '<br/>';
                html += '</div>';

                $('.checkout_address_item_shipping.selected > .address').first().html(html);
                $('.checkout_address_item_shipping.selected > .address').first().attr('postcode', response.postcode);
            }
        });

	});

    $(document).on('click', '#save_billing_address', function(e) {
        e.preventDefault();

        $('.woocommerce-billing-fields').hide();
        $('.billing_address').hide();
        $(this).hide();

        var data = {
            action: 'woocommerce_ajax_save_address',
            address_key: $('.checkout_address_item_billing.selected').first().data('value'),
            address: {
            	first_name: $('#billing_first_name').val(),
                last_name: $('#billing_last_name').val(),
                company: $('#billing_company').val(),
                address_name: $('#billing_address_name').val(),
                address_1: $('#billing_address_1').val(),
                address_2: $('#billing_address_2').val(),
                city: $('#billing_city').val(),
                postcode: $('#billing_postcode').val(),
                country: $('#shipping_country').val(),
            }
        };
        $.ajax({
            type: 'post',
            url: woo_address_book.ajax_url,
            data: data,
            success: function (response) {
                var html = '<div class="address">';
                html += '<span>' + response.first_name + ' ' + response.last_name + '</span><br/>';
                html += response.address_1 + '<br />';
                html += response.postcode + ' ' + response.city + '<br/>';
                html += '</div>';

                $('.checkout_address_item_billing.selected > .address').first().html(html);
            }
        });
    });

    $(document).on('click', '#create_quote', function(e) {
        e.preventDefault();

        var data = {
            action: 'woocommerce_ajax_create_quote'
        }
        $.ajax({
            type: 'post',
            url: quote.ajax_url,
            data: data,
            success: function (response) {
                window.location = response.redirect_url;
            }
        });
	});

    $(document.body).on('updated_cart_totals', function(){
        $(".product_slider_related").remove();
        $(".product_slider_additional").remove();

        if (!$('.product_slider_related').length) {
            window.relatedProductCarousel.insertAfter('.woocommerce-cart-form');
        }
        if (!$('.product_slider_additional').length) {
            window.additionalProductCarousel.insertAfter('.woocommerce-cart-form');
        }
	});

    $(document).on('click', '.my_account_edit_address', function() {
		$('.checkbox-save-billing').hide();
		$('#my_account_address_type').val('my_account_edit_address');
		$('#cancel-edit-address').css('display', 'block');

        $('#shipping_id').val($(this).data('id'));
        $('#shipping_address_name').val($(this).data('address_name'));
        $('#shipping_address_1').val($(this).data('address_1'));
        $('#shipping_address_2').val($(this).data('address_2'));
        $('#shipping_postcode').val($(this).data('postcode'));
        $('#shipping_city').val($(this).data('city'));
        $('#shipping_country').val($(this).data('country'));
        $('#shipping_country').change();

    });

    $(document).on('click', '#cancel-edit-address', function() {
        $('#my_account_address_type').val('my_account_add_address');

        $('#shipping_id').val('');
        $('#shipping_address_name').val('');
        $('#shipping_address_1').val('');
        $('#shipping_address_2').val('');
        $('#shipping_postcode').val('');
        $('#shipping_city').val('');
    	$('#shipping_country').val('');
        $('#cancel-edit-address').hide();
	});
    
})(jQuery);

